import localForage from "localforage";

export default async function getStorage(key_name) {
	const value = await localForage.getItem(key_name);

	return value;
}
